import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// Import de Context
import { useDataContext } from "../Context/dataContext";

// Import de Hooks
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useCurrencyPrice } from "../Hooks/useCurrencyPrice";
import { useFetchData } from "../Hooks/useFetchData";

// Import de Navbar
import { UserNavbar } from "../Components/UserNavbar";

// Import de Gráfica
// import WalletLineChart from "../Components/WalletLineChart";

//Importaciones de Imagenes de banderas
import europa1 from "../Assets/Images/europa1.png";
import usa1 from "../Assets/Images/usa1.png";
import uk1 from "../Assets/Images/uk1.png";

// Importaciones para Loadings
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Importaciones de Iconos
import {
  FaEye,
  FaEyeSlash,
  FaTimes,
  FaExchangeAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
} from "react-icons/fa";
import {
  HiOutlineUpload,
  HiOutlinePaperAirplane,
  HiOutlineCurrencyDollar,
  HiOutlineDocumentText,
} from "react-icons/hi";

// Importaciones para KYC
import VerificationImage from "../Assets/Images/verification.png";
import kycanimation from "../Assets/Images/kycanimation.gif";
import { useKycLink } from "../Hooks/useKycLink";

function Changes() {
  // Context and hooks
  useAxiosInterceptors();
  const { url, accessToken } = useDataContext();
  const history = useHistory();
  const { exchangeRates } = useCurrencyPrice();

  //User data
  const { user, movements } = useFetchData(accessToken.access_token);

  // KYC Link
  const { kycLink, fetchKycLink } = useKycLink({
    user,
    accessToken: accessToken.access_token,
    url,
  });

  // Estados para manejar el menú de opciones y el modal de comprobante
  const [openMenu, setOpenMenu] = useState(null);
  const [showComprobanteModal, setShowComprobanteModal] = useState(false);
  const [comprobanteImage, setComprobanteImage] = useState(null);

  // Modal Motivo de rechazo
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectComment, setRejectComment] = useState(null);

  // Funciones para abrir y cerrar los modales
  const [modalOpen, setModalOpen] = useState(false);
  const [secondModalOpen, setSecondModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const toggleSecondModal = () => {
    setModalOpen(false);
    setSecondModalOpen(!secondModalOpen);
  };

  // Renderiza el estado de verificación del usuario
  const renderVerificationStatus = (verif) => {
    if (verif === "N") {
      return (
        <button className="user-status no-verificado" onClick={toggleModal}>
          <FaTimesCircle /> Usuario no verificado, Haz click aqui para
          verificarte
        </button>
      );
    }

    if (verif === "E") {
      return (
        <button className="user-status en-espera" onClick={toggleSecondModal}>
          <FaClock /> Verificación pendiente
        </button>
      );
    }

    if (verif === "S") {
      return (
        <button className="user-status verificado">
          <FaCheckCircle /> Usuario verificado
        </button>
      );
    }

    return null;
  };

  // Verifica el estado de verificación del usuario
  const checkUserVerification = (verif) => {
    if (verif === "N") {
      toggleModal();
      return false;
    }
    if (verif === "E") {
      toggleSecondModal();
      return false;
    }
    if (verif === "S") {
      return true;
    }
    return false;
  };

  // Estados para mostrar/ocultar saldos
  const [showBalances, setShowBalances] = useState({
    eur: true,
    usd: true,
    gbp: true,
  });

  // Utilidad para Mapeo de Banderas
  const flagMap = {
    eur: europa1,
    usd: usa1,
    gbp: uk1,
  };
  const [showRatesModal, setShowRatesModal] = useState(false);

  // Utilidad para mapeo de estados
  const statusMap = {
    V: { icon: <FaCheckCircle />, text: "Verificado" },
    E: { icon: <FaClock />, text: "En espera" },
    R: { icon: <FaTimesCircle />, text: "Rechazado" },
  };

  // Utilidad para mostrar la flecha y color según tipo
  const getTypeArrow = (type) =>
    type === "Retiro" ? (
      <span title="Retiro" style={{ color: "#e53935" }}>
        ↑
      </span>
    ) : (
      <span title="Ingreso" style={{ color: "#43a047" }}>
        ↓
      </span>
    );

  // Utilidad para mostrar el beneficiario
  const getBeneficiary = (r) =>
    r.mov_type === "Deposito"
      ? `${user?.use_name || ""} ${user?.use_lastName || ""}`
      : r.AccountsBsUser?.accbsUser_owner || "beneficiario";

  // Utilidad para mostrar el monto principal
  const getMainAmount = (r) =>
    r.mov_type === "Deposito"
      ? `${r.mov_currency} ${r.mov_amount}`
      : `${r.mov_oldCurrency} ${r.mov_oldAmount}`;

  // Utilidad para mostrar el monto en otras divisas
  const getOtherAmount = (r) =>
    r.mov_type === "Deposito" ? "Ingreso" : `${r.mov_currency} ${r.mov_amount}`;

  // Manejo de eventos
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".options-wrapper")) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    setTimeout(() => window.dispatchEvent(new Event("resize")), 100);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [kycLink]);

  // Formato de fecha actual
  const currentDate = new Date().toLocaleDateString("es-ES", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="changes-page">
      {/* Header */}
      <div className="changes-header">
        <div className="holiday-notice">
          <div className="holiday-icon">🎄</div>

          <div className="holiday-content">
            <h4>RemesaEspana te desea ¡Feliz Navidad! ✨</h4>

            <p>
              Queremos informarte que los días
              <strong> 25 de diciembre </strong> y<strong> 1 de enero </strong>
              <span className="highlight">
                {" "}
                no se estarán procesando pagos{" "}
              </span>
              debido a las festividades.
            </p>

            <p>
              Agradecemos tu confianza durante este año 💚 Seguimos trabajando
              para que tu dinero llegue
              <strong> rápido, seguro y con la mejor tasa</strong>.
            </p>

            <p className="holiday-footer">
              🎁 Que esta Navidad esté llena de paz, unión y prosperidad para ti
              y tu familia.
            </p>
          </div>
        </div>

        <div className="header-row">
          <button
            className="user-avatar"
            onClick={() => history.push("/Profile")}
          >
            {user?.use_profileImg ? (
              <img
                src={`${url}/Users/profileImg/${user.use_profileImg}`}
                alt="Foto de perfil"
                className="profile-avatar"
              />
            ) : (
              <Skeleton circle width={48} height={48} />
            )}
          </button>
          <div className="header-text">
            <h2>
              Hola, {user?.use_name || <Skeleton width={100} />}{" "}
              <span className="wave" role="img" aria-label="wave">
                👋
              </span>
            </h2>
            <p className="current-date">{currentDate}</p>
            {renderVerificationStatus(user?.use_verif)}
          </div>
        </div>
      </div>

      {/* Wallet cards */}
      <div className="wallet-section">
        {["eur", "gbp", "usd"].map((currency) => (
          <div className="wallet-card" key={currency}>
            <div className="wallet-card-top">
              <div className="wallet-card-label">
                <h4>
                  {currency.toUpperCase()} (
                  {currency === "eur" ? "€" : currency === "usd" ? "$" : "£"})
                </h4>
                <span className="wallet-subtitle">Saldo disponible</span>
              </div>
              <img
                src={flagMap[currency]}
                alt={currency}
                className="wallet-card-flag"
              />
            </div>

            <div className="wallet-card-middle">
              <div className="wallet-card-balance">
                {user ? (
                  showBalances[currency] ? (
                    <>
                      {user[
                        `use_amount${
                          currency.charAt(0).toUpperCase() + currency.slice(1)
                        }`
                      ].toFixed(2)}{" "}
                      {currency.toUpperCase()}
                    </>
                  ) : (
                    "••••••••"
                  )
                ) : (
                  <Skeleton width={80} />
                )}
              </div>
              <button
                className="toggle-visibility"
                onClick={() =>
                  setShowBalances((prev) => ({
                    ...prev,
                    [currency]: !prev[currency],
                  }))
                }
                aria-label="Mostrar/Ocultar saldo"
              >
                {showBalances[currency] ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <div className="wallet-card-footer">
              <div className="options-wrapper">
                <button
                  className="card-options"
                  onClick={() =>
                    setOpenMenu(openMenu === currency ? null : currency)
                  }
                  aria-label="Opciones"
                >
                  &#8942;
                </button>
                {openMenu === currency && (
                  <div className="card-options-menu visible">
                    <button onClick={() => history.push("/Recharge")}>
                      Recargar
                    </button>
                    <button onClick={() => history.push("/SendMoney")}>
                      Enviar dinero
                    </button>
                    <button onClick={() => history.push("/Movements")}>
                      Movimientos
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="wallet-info-note">
        <FaCheckCircle className="info-icon" />
        <div className="info-text">
          <strong>¿Cómo empezar?</strong>
          <p>
            Para ver nuestros datos bancarios, realiza primero una{" "}
            <span className="highlight">recarga</span>. Una vez el saldo se
            refleje en tu balance, podrás{" "}
            <span className="highlight">enviar dinero</span> de forma inmediata.
          </p>
        </div>
      </div>

      {/* Action buttons */}
      <div className="wallet-summary-actions">
        <button
          onClick={() => {
            if (checkUserVerification(user?.use_verif)) {
              history.push("/Recharge");
            }
          }}
          className="wallet-button-primary"
        >
          <HiOutlineUpload />
          Recargar
        </button>
        <button
          onClick={() => {
            if (checkUserVerification(user?.use_verif)) {
              history.push("/SendMoney");
            }
          }}
          className="wallet-button-secondary"
        >
          <HiOutlinePaperAirplane />
          Enviar dinero
        </button>
        <button
          onClick={() => setShowRatesModal(true)}
          className="wallet-button-secondary"
        >
          <HiOutlineCurrencyDollar /> Ver tasas
        </button>
      </div>

      {/* Movements Table */}
      <div className="remesas-table">
        <h3>Historial de remesas</h3>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Beneficiario</th>
                <th>Monto</th>
                <th>Monto (otras divisas)</th>
                <th>Remesa Nº</th>
                <th>Tipo</th>
                <th>Estatus</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {movements
                .slice()
                .reverse()
                .slice(0, 6)
                .map((r, idx) => (
                  <tr key={idx}>
                    <td>
                      <strong>{getBeneficiary(r)}</strong>
                    </td>
                    <td>{getMainAmount(r)}</td>
                    <td>{getOtherAmount(r)}</td>
                    <td>{r.mov_ref}</td>
                    <td style={{ textAlign: "center", fontSize: "1.2em" }}>
                      {getTypeArrow(r.mov_type)}
                    </td>
                    <td>
                      <span className={`status-tag ${r.mov_status}`}>
                        {statusMap[r.mov_status]?.icon}{" "}
                        {statusMap[r.mov_status]?.text}
                      </span>
                    </td>
                    <td>
                      {r.mov_status === "V" && r.mov_img ? (
                        <button
                          className="comprobante-btn"
                          onClick={() => {
                            setComprobanteImage(
                              `${url}/Movements/image/${r.mov_img}`
                            );
                            setShowComprobanteModal(true);
                          }}
                        >
                          <HiOutlineDocumentText /> Comprobante
                        </button>
                      ) : r.mov_status === "R" && r.mov_comment ? (
                        <button
                          className="comprobante-btn"
                          onClick={() => {
                            setRejectComment(r.mov_comment);
                            setShowRejectModal(true);
                          }}
                        >
                          <HiOutlineDocumentText /> Motivo
                        </button>
                      ) : (
                        "—"
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div className="table-footer">
            <button
              className="ver-todos-btn"
              onClick={() => history.push("/Movements")}
            >
              Ver todos los movimientos →
            </button>
          </div>
        </div>
      </div>

      {/* Comprobante Modal */}
      {showComprobanteModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button
              className="close-btn"
              onClick={() => setShowComprobanteModal(false)}
            >
              <FaTimes />
            </button>
            <img
              src={comprobanteImage}
              alt="Comprobante"
              style={{ maxWidth: "100%", borderRadius: "12px" }}
            />
          </div>
        </div>
      )}

      {/* Modal Motivo de rechazo */}
      {showRejectModal && rejectComment && (
        <div
          className="modal-overlay comprobante-modal"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="modal-rechazo-mov"
            style={{
              background: "#fff",
              padding: "2rem 2.5rem",
              borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              textAlign: "center",
              minWidth: "300px",
              maxWidth: "90vw",
              position: "relative",
            }}
          >
            <button
              className="close-btn"
              onClick={() => {
                setShowRejectModal(false);
                setRejectComment(null);
              }}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
                color: "#676767",
              }}
            >
              <FaTimes />
            </button>
            <p
              className="rechazo-text"
              style={{
                fontSize: "1.1rem",
                color: "#d32f2f",
                marginTop: "2.5rem",
                marginBottom: "0.5rem",
                wordBreak: "break-word",
              }}
            >
              <strong style={{ color: "#333" }}>Motivo de rechazo:</strong>{" "}
              {rejectComment}
            </p>
          </div>
        </div>
      )}

      {/* KYC Modal */}
      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal-content kyc-modal">
            <button className="close-btn" onClick={toggleModal}>
              <FaTimes />
            </button>
            <h3>¡Necesitas verificación!</h3>
            <img
              src={VerificationImage}
              alt="Verificación requerida"
              className="modal-image centered"
            />

            <p className="modal-text">
              Para realizar el cambio de divisas necesitamos verificar que eres
              el propietario de la cuenta. Verifica tu identidad para empezar a
              cambiar.
            </p>
            <div className="center-btn">
              <button className="submit-btn" onClick={toggleSecondModal}>
                ¡HAZ CLICK AQUI PARA VERIFICARTE!
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Second KYC Modal */}
      {secondModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content kyc-modal-wide">
            <button className="close-btn" onClick={toggleSecondModal}>
              <FaTimes />
            </button>
            <h3>¡Prepara tu documentación!</h3>

            <img src={kycanimation} alt="KYC" className="kyc-animation" />

            <div className="kyc-instructions">
              <p>
                <strong>Para realizar el proceso de KYC necesitas:</strong>
              </p>
              <ul>
                <li>
                  Identificación, tarjeta de residencia, pasaporte (vigente)
                </li>
                <li>Video identificación</li>
              </ul>

              <p>
                <strong>Para evitar rechazo:</strong>
              </p>
              <ul>
                <li>No se aceptan NIE hoja blanca o cartón rojo</li>
                <li>Foto frontal y reverso si es identificación</li>
                <li>Se deben ver las 4 esquinas, buena visibilidad</li>
              </ul>
            </div>

            <div className="center-btn">
              <button className="submit-btn" onClick={fetchKycLink}>
                Ir a la verificación
              </button>
              <button
                className="submit-btn secondary"
                onClick={toggleSecondModal}
              >
                Volver
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de tasas de cambio */}
      {showRatesModal && (
        <div className="modal-overlay">
          <div className="modal-content rates-modal">
            <button
              className="close-btn"
              onClick={() => setShowRatesModal(false)}
            >
              <FaTimes />
            </button>

            <div className="rates-header">
              <div className="rates-icon">
                <FaExchangeAlt />
              </div>
              <h3>Tasas de cambio actualizadas</h3>
              <p>Consulta las conversiones disponibles</p>
            </div>

            <div className="rates-grid">
              {exchangeRates.map((rate, idx) => {
                const [from, to] = rate.label.split(" a ");
                return (
                  <div key={idx} className="rate-card">
                    <div className="rate-card-header">
                      {from} <span className="arrow">→</span> {to}
                    </div>
                    <div className="rate-card-value">
                      {rate.value} <span>{rate.currency}</span>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="center-btn">
              <button
                className="submit-btn"
                onClick={() => setShowRatesModal(false)}
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}

      <UserNavbar logOut={user?.use_email} />
    </div>
  );
}

export { Changes };
